import { useState } from 'react';

export function useUsdAmountSelection(initialValue = 0) {
  const [selectedAmount, setSelectedAmount] = useState<number>(initialValue);
  const [customAmount, setCustomAmount] = useState<string>('');

  const handlePresetClick = (preset: number) => {
    setSelectedAmount(preset);
    setCustomAmount('');
  };

  const handleCustomAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '' || /^\d+$/.test(value)) {
      setCustomAmount(value);
      setSelectedAmount(0);
    }
  };

  const reset = () => {
    setSelectedAmount(initialValue);
    setCustomAmount('');
  };

  const getFinalAmount = () =>
    selectedAmount || (customAmount ? parseInt(customAmount) : 0);

  const isValid = () => getFinalAmount() >= 1;

  return {
    selectedAmount,
    customAmount,
    handlePresetClick,
    handleCustomAmountChange,
    getFinalAmount,
    isValid,
    reset,
  };
}
